import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import Form from '../../../../../components/Form/Form';
import MobileModalForm from '../../../../../components/Form/MobileModalForm';
import * as formInputNames from '../../../../../consts/form/formInputNames';
import * as localizationKeys from '../../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../../../services/localization/localizationService';
import log from '../../../../../services/logger/log';
import {makeSelectorDeviceGroupProfile} from '../../../../../state/selectors/settings';
import helpers from '../../../../../utils/helpers';
import deviceGroupsModalService from './deviceGroupsModalService';

const DeviceGroupsModal = (props) => {
    const {onOk, onCancel, modalType, groupID, initialData} = props;
    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();

    const deviceGroupProfile = useSelector(makeSelectorDeviceGroupProfile()) || {};
    const modalData = deviceGroupsModalService.getDeviceGroupsModalContent(modalType, deviceGroupProfile);

    const {formContent, title, submitButton, cancelButton, initialValues} = modalData || {};

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            values.groupID = groupID;

            helpers.runFunction(onOk, values);
        } catch (error) {
            log.error(`DeviceGroupsModal - validate failed: ${error}`);
        }
    };

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
        const unassignedTypesFromProps = initialData?.unappliedDeviceTypes;

        if (unassignedTypesFromProps && Array.isArray(unassignedTypesFromProps)) {
            const deviceGroupsTypesField = formContent.find(
                (field) => field.name === formInputNames.DEVICE_GROUPS_TYPES
            );

            if (deviceGroupsTypesField && deviceGroupsTypesField.requestOptions) {
                deviceGroupsTypesField.requestOptions.options = [
                    ...(deviceGroupsTypesField.requestOptions.options || []),
                    ...unassignedTypesFromProps,
                ];
            }
        }

        return () => {
            form.resetFields();
        };
    }, [formContent, form, initialValues, initialData]);

    const handleChange = (value, name) => {
        switch (name) {
            case formInputNames.DEVICE_GROUPS_TYPES:
                const isValueArrayEmpty = !value?.length;

                if (isValueArrayEmpty) {
                    form.setFieldsValue({[name]: undefined});
                }
                break;
            default: {
                form.setFieldsValue({[name]: value});
            }
        }
    };

    if (isMobile)
        return (
            <MobileModalForm
                form={form}
                formName='settings-devicegroupsmodal'
                title={title}
                closeLabel={strings[localizationKeys.SETTINGS_MOBILE_CLOSE_FORM]}
                onCancel={onCancel}
                onFinish={onFinish}
                formFields={formContent}
                submitButton={submitButton}
                cancelButton={cancelButton}
                initialValues={initialValues}
                handleChange={handleChange}
            />
        );

    return (
        <Form
            handleChange={handleChange}
            closeModal={onCancel}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formContent}
            cancelButton={cancelButton}
            formInstance={form}
            initialValues={initialValues}
        />
    );
};

export default React.memo(DeviceGroupsModal);
